import React from 'react';
import { FormattedMessage } from "react-intl";

export default function ErrorComponent({ error, resetErrorBoundary }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
      <h2><FormattedMessage id="Model.errorMessage" /></h2>
      <button onClick={resetErrorBoundary}><FormattedMessage id="Model.retryButton" /></button>
    </div>
  );
}